import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  environmentName: 'development',
  apiUrl: 'https://api.dev.piledco.com',
  region: 'us-east-2',
  userPoolId: 'us-east-2_dervBPANC',
  userPoolWebClientId: '5pclchbdtqqtjn6e2v87eiuj30',

  debug: true,
  cognitoConfig: {
    UserPoolId: 'us-east-2_dervBPANC',
    ClientId: '78k75c2nbir5dqarjouq0seoa0',
    Region: 'us-east-2',
    IdentityPoolId: 'us-east-2:xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
    oauth: {
      domain: 'https://dev-piled.auth.us-east-2.amazoncognito.com',
      scope: ['email', 'openid', 'profile'],
      redirectSignIn: 'capacitor://localhost',
      redirectSignOut: 'capacitor://localhost',
      responseType: 'code'
    }
  }
}; 